<template lang="pug">
  .leaping-bunny
    p.intro-text.xs-f-small.lg-f-medium.max-at-tweak.text-center.xs-mb-100m
      | Learn more about our&nbsp;
      a(href="/hair-dye-ingredients" class="underline" target="_self") ingredient philosophy
      | .

    .leaping-bunny-img.a-box-xs-1x1
      .a-box-content
        img-box(media-id="4227" loading="lazy")

    .leaping-bunny-text.xs-f-small.lg-f-medium.max-at-tweak.text-center.align-center.xs-mb-300m
      p
        | Join us against animal cruelty.
      p
        a(href="/blog/join-us-against-animal-cruelty" class="underline" target="_self") Learn more
        |  about our cruelty-free Leaping Bunny certification.

</template>

<script>
  export default {
    name: "LeapingBunny"
   };
</script>

<style scoped lang="stylus">
  .leaping-bunny
    .intro-text
    .leaping-bunny-text
      text-align center

    .leaping-bunny-img
      margin auto
      width 5em

</style>